import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const CabinCrewUnitHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Servicio a Bordo"
    text="Gestión de servicio a bordo: movimientos, asignaciones, programación y tareo."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ TrafficUnit }) => ({
  cards: TrafficUnit.CabinCrewUnitHome.get('cards'),
  breadcrumbs: TrafficUnit.CabinCrewUnitHome.get('breadcrumbs'),
});

CabinCrewUnitHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(CabinCrewUnitHome);